import Api from '@/api'

export default {
  state: {
    plan_list: [],
    filter_list: []
  },
  actions: {
    async LOAD_PLAN_PARAMS({}, id) {
      try {
        const res = await Api.load_plan_params(id)
        const {status, data} = res
        if (status === 200) {
          return data
        } else {
          throw `Load plan params status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },
    async SET_PLAN_PARAMS({}, payload) {
      const {plan_id, params} = payload
      try {
        const res = await Api.set_plan_params({plan_id, params})
        if (res.status === 201) {
          return true
        } else {
          throw `Set plan params status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },
    async LOAD_PLAN_DATA({}, {plan_id, reqQuery}) {
      const query = {}
      Object.keys(reqQuery).forEach((key) => {
        if (!Array.isArray(reqQuery[key])) {
          query[key] = reqQuery[key]
        } else {
          query[key] = reqQuery[key]
            .map((n, index) => `${key}[${index}]=${n}`)
            .join('&')
        }
      })

      try {
        const res = await Api.load_plan_data({plan_id, reqQuery})
        const {status, data} = res
        if (status === 200) {
          return data
        } else {
          throw `Load plan data status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },

    async LOAD_PLAN_LIST({commit}) {
      try {
        const res = await Api.load_plan_list()
        const {status, data} = res
        if (status === 200) {
          return data //commit('SET_PLAN_LIST', data)
        } else {
          throw `Load plan params status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },
    async GENERATE_PLAN_DATA({}, payload) {
      const {plan_id, type} = payload
      try {
        const res = await Api.generate_plan_data({plan_id, type})
        const {status} = res
        if (status === 201) {
          return true
        } else {
          throw `Generate plan data status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },
    async PLAN_GENERATE({}) {
      try {
        const payload = {total_budget: 0, periodic_budget: 0, routine_budget: 0}
        const res = await Api.plan_budget_generate(payload)
        const {status, data} = res

        if (status === 201) {
          return data.plan_id
        } else {
          throw `Generate new plan status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },
    async LOAD_PLAN_FILTER_LIST({commit}, {plan_id, type}) {
      try {
        const res = await Api.load_plan_filters({plan_id, type})
        const {status, data} = res
        if (status === 200) {
          commit('SET_PLAN_FILTER_LIST', data)
        } else {
          throw `Load plan filters status: ${status}`
        }
      } catch (err) {
        throw err
      }
    },
    async SAVE_PLAN_DATA({}, payload) {
      try {
        const res = await Api.save_plan_data(payload)
        const {status} = res
        if (status === 201) {
          return true
        } else {
          throw `Save plan data status: ${status}`
        }
      } catch (err) {
        throw err
      }
    }
  },
  mutations: {
    SET_PLAN_LIST(state, list) {
      state.plan_list = [...list]
    },
    SET_PLAN_FILTER_LIST(state, list) {
      state.filter_list = [...list]
    }
  },
  getters: {}
}
